// extracted by mini-css-extract-plugin
export default {"fieldLabel":"c-b_gp","fieldLabel__requiredIndicator":"c-b_gq"};